/**
 * Labstep
 *
 * @module components/Modal/Edit
 * @desc Edit modal for experiment and protocol elements in prosemirror
 *
 * TODO Refactor as part of prosemirror folder
 */

import { MoleculeActionEditContainer as MoleculeActionEdit } from 'labstep-web/components/Molecule/Action/Edit';
import { ProtocolConditionSmartTableModal } from 'labstep-web/components/ProtocolCondition/SmartTable/Modal';
import { ProtocolValueSmartTableModal } from 'labstep-web/components/ProtocolValue/SmartTable/Modal';
import { TableModal } from 'labstep-web/components/Table/Modal';
import { withActiveEditModal } from 'labstep-web/containers/ActiveEditModal';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import ProtocolChildRouter from 'labstep-web/containers/Router/ProtocolChild';
import type { Entity } from 'labstep-web/models/entity.model';
import { EntityView } from 'labstep-web/models/entity-view.model';
import { Experiment } from 'labstep-web/models/experiment.model';
import { Metadata } from 'labstep-web/models/metadata';
import { Molecule } from 'labstep-web/models/molecule.model';
import { Protocol } from 'labstep-web/models/protocol.model';
import { ProtocolTable } from 'labstep-web/models/protocol-table.model';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import type React from 'react';
import { Redirect } from 'react-router-dom';
import type { IModalEditProps } from './types';

export const ModalEdit: React.FC<IModalEditProps> = ({
  activeEditModal,
  setActiveEditModal,
  parent,
}) => {
  if (!activeEditModal) {
    return null;
  }

  let modal: null | ((entity: Entity) => any) = null;
  switch (activeEditModal.entityName) {
    case ProtocolValue.entityName: {
      setActiveEditModal(null);
      return (
        <ProtocolChildRouter
          route="value_show"
          id={activeEditModal.id}
        >
          {({ to }) => (
            <Redirect
              to={{ pathname: to, state: { expanded: true } }}
            />
          )}
        </ProtocolChildRouter>
      );
    }
    case Metadata.entityName: {
      setActiveEditModal(null);
      return (
        <ProtocolChildRouter
          route="metadata_show"
          id={activeEditModal.id}
        >
          {({ to }) => (
            <Redirect
              to={{ pathname: to, state: { expanded: true } }}
            />
          )}
        </ProtocolChildRouter>
      );
    }
    case ProtocolTable.entityName:
      modal = (entity: Entity) => (
        <TableModal
          allowLocking={
            parent.entityName === Protocol.entityName ||
            parent.isTemplate
          }
          table={entity as ProtocolTable}
          viewComponent={null}
          onDone={() => setActiveEditModal(null)}
          open
        />
      );
      break;

    case EntityView.entityName:
      modal = (entity: Entity) => {
        if (
          (entity as EntityView).entity_name ===
          ProtocolValue.entityName
        ) {
          return (
            <ProtocolValueSmartTableModal
              experimentOrProtocol={parent}
              entityView={entity as EntityView}
              open
            />
          );
        }
        return (
          <ProtocolConditionSmartTableModal
            experimentOrProtocol={parent}
            entityView={entity as EntityView}
            open
          />
        );
      };

      break;
    case Molecule.entityName:
      modal = (entity: Entity) => (
        <MoleculeActionEdit
          molecule={entity as Molecule}
          canEdit
          viewComponent={null}
          onDone={() => setActiveEditModal(null)}
          open
          parent={parent}
        />
      );
      break;
    default:
      break;
  }

  return modal ? (
    <EntityReadEntityContainer
      entityName={activeEditModal.entityName}
      id={activeEditModal.id}
    >
      {({ entity }) => modal(entity)}
    </EntityReadEntityContainer>
  ) : null;
};

export default withActiveEditModal(ModalEdit);
